import React, {useEffect, useState, useRef} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import api from "../../api";
import {Button, Col, Drawer, Form, Input, InputNumber, Modal, Row, Select, Switch, Table, Tabs, Tag, message} from "antd";
import {CheckOutlined, CloseOutlined, CopyOutlined, LinkOutlined, PlusOutlined, PrinterOutlined, DeleteOutlined, EditOutlined} from '@ant-design/icons';
import {QRCodeSVG} from 'qrcode.react';
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/nl';

dayjs.extend(relativeTime);
dayjs.locale('nl');

function generateRandomCode(length = 5) {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}


const FlyerContent = React.forwardRef(({affiliate}, ref) => {
    const url = `https://oogst.app/${affiliate.slug}`;

    return (
        <div ref={ref} style={{
            width: '210mm',
            marginTop: '30mm',
            height: '297mm',
            fontFamily: "'Nunito', sans-serif",
            background: '#ffffff',
            color: '#2d3436',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20mm 20mm 15mm 20mm',
            boxSizing: 'border-box',
        }}>
            <br/><br/><br/>
            <h1 style={{
                fontSize: '34px',
                fontWeight: 800,
                color: '#2d7d46',
                textAlign: 'center',
                lineHeight: 1.2,
                marginBottom: '5mm',
                margin: '0 0 5mm 0',
            }}>
                Een succesvolle moestuin<br/>begint met een goed plan
            </h1>
            <p style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#555',
                textAlign: 'center',
                marginBottom: '10mm',
                lineHeight: 1.4,
            }}>
                Het overzicht houden is het lastigste aan een moestuin.<br/>Oogst.app geeft je het overzicht dat je
                nodig hebt.
            </p>
            <div style={{
                marginBottom: '10mm',
                width: '100%',
                alignItems: 'center',
            }}>
                {[
                    'Weet precies wanneer en hoeveel je moet zaaien',
                    'Nooit meer een leeg bed of mislukte oogst',
                    'Automatische takenlijst \u2014 zie direct wat je moet doen',
                    'Grootste zadendatabase van Nederland (2.500+ gewassen)',
                    'Altijd je planning in je broekzak',
                    'Gratis community voor vragen en tips',
                ].map((text, i) => (
                    <div key={i} style={{
                        fontSize: '15px',
                        fontWeight: 600,
                        color: '#333',
                        textAlign: 'center',
                    }}>
                        <span style={{color: '#2d7d46', fontSize: '18px'}}>&#10003;</span>&nbsp;&nbsp;
                        <span>{text}</span>
                    </div>
                ))}
            </div>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10mm',
                marginBottom: '10mm',
                textAlign: 'center',
            }}>
                <div>
                    <div style={{fontSize: '22px', fontWeight: 800, color: '#2d7d46'}}>4.000+</div>
                    <div style={{fontSize: '11px', fontWeight: 600, color: '#777'}}>tuinders</div>
                </div>
                <div>
                    <div style={{fontSize: '22px', fontWeight: 800, color: '#2d7d46'}}>254.000+</div>
                    <div style={{fontSize: '11px', fontWeight: 600, color: '#777'}}>gewassen geoogst</div>
                </div>
                <div>
                    <div style={{fontSize: '22px', fontWeight: 800, color: '#2d7d46'}}>110.000+</div>
                    <div style={{fontSize: '11px', fontWeight: 600, color: '#777'}}>m&sup2; in de planner</div>
                </div>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: 'auto',
                marginBottom: '5mm',
            }}>
                <p style={{
                    fontSize: '15px',
                    fontWeight: 700,
                    color: '#2d7d46',
                    marginBottom: '4mm',
                }}>
                    Scan de QR-code en probeer het gratis
                </p>
                <QRCodeSVG value={url} size={130}/>
                <span style={{
                    fontSize: '22px',
                    fontWeight: 800,
                    color: '#2d7d46',
                    marginTop: '4mm',
                }}>
                    {url.replace('https://', '')}
                </span>
            </div>
            <p style={{
                marginTop: '5mm',
                fontSize: '14px',
                color: '#777',
                textAlign: 'center',
            }}>
                Gratis te proberen
            </p>
        </div>
    );
});

export default function AdminAffiliates() {
    const navigate = useNavigate();
    const location = useLocation();
    const [affiliates, setAffiliates] = useState([]);
    const [affiliateRequests, setAffiliateRequests] = useState([]);
    const [discountCodes, setDiscountCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false);
    const [editingDiscount, setEditingDiscount] = useState(null);
    const [flyerAffiliate, setFlyerAffiliate] = useState(null);
    const [denyModalOpen, setDenyModalOpen] = useState(false);
    const [denyingRequest, setDenyingRequest] = useState(null);
    const [form] = Form.useForm();
    const [discountForm] = Form.useForm();
    const [denyForm] = Form.useForm();
    const flyerRef = useRef();
    const [activeSubTab, setActiveSubTab] = useState('requests');

    const getActiveTab = () => {
        if (location.pathname === '/admin/affiliates') return 'affiliates';
        if (location.pathname === '/admin/suppliers') return 'suppliers';
        if (location.pathname === '/admin/icons') return 'icons';
        if (location.pathname === '/admin/users') return 'users';
        if (location.pathname === '/admin/blog') return 'blog';
        if (location.pathname === '/admin/ad-spends') return 'ad-spends';
        return 'stats';
    };

    const handleTabChange = (key) => {
        switch(key) {
            case 'stats': navigate('/admin'); break;
            case 'suppliers': navigate('/admin/suppliers'); break;
            case 'icons': navigate('/admin/icons'); break;
            case 'users': navigate('/admin/users'); break;
            case 'blog': navigate('/admin/blog'); break;
            case 'ad-spends': navigate('/admin/ad-spends'); break;
            case 'affiliates': navigate('/admin/affiliates'); break;
            default: navigate('/admin');
        }
    };

    useEffect(() => {
        loadAffiliates();
        loadAffiliateRequests();
        loadDiscountCodes();
    }, []);

    const loadAffiliates = () => {
        setLoading(true);
        api.getAffiliates()
            .then(setAffiliates)
            .finally(() => setLoading(false));
    };

    const loadAffiliateRequests = () => {
        api.getAffiliateRequests().then(setAffiliateRequests);
    };

    const loadDiscountCodes = () => {
        api.getDiscountCodes().then(setDiscountCodes);
    };

    const handleCreate = (prefill = {}) => {
        form.resetFields();
        form.setFieldsValue({
            discount_code: generateRandomCode(),
            discount_max_usage: 1000,
            ...prefill,
        });
        setDrawerOpen(true);
    };

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            const requestId = values.affiliate_request_id;
            const submitData = {...values};
            delete submitData.affiliate_request_id;

            api.createAffiliate(submitData).then(() => {
                // Approve the affiliate request after successful company creation
                const approvePromise = requestId
                    ? api.approveAffiliateRequest(requestId, { slug: submitData.slug, discount_code: submitData.discount_code })
                    : Promise.resolve();

                approvePromise.then(() => {
                    message.success('Affiliate aangemaakt');
                    setDrawerOpen(false);
                    form.resetFields();
                    loadAffiliates();
                    loadAffiliateRequests();
                    loadDiscountCodes();
                });
            }).catch(() => message.error('Fout bij aanmaken'));
        });
    };

    const handleApproveRequest = (request) => {
        // Open the create affiliate drawer pre-filled with request data
        const slug = request.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const discountAmount = 36 * (request.member_discount / 100);
        handleCreate({
            name: request.name,
            slug: slug,
            affiliate_iban: request.iban,
            discount_amount: discountAmount > 0 ? discountAmount : undefined,
            affiliate_request_id: request.id,
        });
    };

    const handleDenyRequest = (request) => {
        setDenyingRequest(request);
        denyForm.resetFields();
        setDenyModalOpen(true);
    };

    const handleDenySubmit = () => {
        denyForm.validateFields().then((values) => {
            api.denyAffiliateRequest(denyingRequest.id, values.denial_reason).then(() => {
                message.success('Aanvraag afgewezen');
                setDenyModalOpen(false);
                setDenyingRequest(null);
                loadAffiliateRequests();
            });
        });
    };

    const handlePrintFlyer = (affiliate) => {
        setFlyerAffiliate(affiliate);
        setTimeout(() => {
            const printContent = flyerRef.current;
            if (!printContent) return;

            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap" rel="stylesheet">
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        @page { size: A4; margin: 0; }
                        body { font-family: 'Nunito', sans-serif; }
                    </style>
                </head>
                <body>
                    ${printContent.innerHTML}
                </body>
                </html>
            `);
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
            }, 1000);
        }, 100);
    };

    // Discount code handlers
    const handleCreateDiscount = () => {
        setEditingDiscount(null);
        discountForm.resetFields();
        discountForm.setFieldsValue({is_active: true, max_usage: 1000});
        setDiscountDrawerOpen(true);
    };

    const handleEditDiscount = (record) => {
        setEditingDiscount(record);
        discountForm.setFieldsValue(record);
        setDiscountDrawerOpen(true);
    };

    const handleDiscountSubmit = () => {
        discountForm.validateFields().then((values) => {
            const action = editingDiscount
                ? api.updateDiscountCode(editingDiscount.id, values)
                : api.createDiscountCode(values);

            action.then(() => {
                message.success(editingDiscount ? 'Kortingscode bijgewerkt' : 'Kortingscode aangemaakt');
                setDiscountDrawerOpen(false);
                loadDiscountCodes();
            }).catch(() => message.error('Fout bij opslaan'));
        });
    };

    const handleDeleteDiscount = (id) => {
        api.deleteDiscountCode(id).then(() => {
            message.success('Kortingscode verwijderd');
            loadDiscountCodes();
        });
    };

    const pendingRequests = affiliateRequests.filter(r => !r.is_processed);
    const processedRequests = affiliateRequests.filter(r => r.is_processed);

    const affiliateColumns = [
        {title: 'ID', dataIndex: 'id', key: 'id', width: 80},
        {
            title: 'Logo', dataIndex: 'logo', key: 'logo', width: 80,
            render: (logo) => logo ? <img src={logo} alt="Logo" style={{maxWidth: 50, maxHeight: 35}} /> : null,
        },
        {title: 'Naam', dataIndex: 'name', key: 'name'},
        {
            title: 'Slug', dataIndex: 'slug', key: 'slug',
            render: (slug) => slug ? (
                <a href={`https://oogst.app/${slug}`} target="_blank" rel="noopener noreferrer">
                    oogst.app/{slug}
                </a>
            ) : null,
        },
        {title: 'IBAN', dataIndex: 'affiliate_iban', key: 'affiliate_iban'},
        {
            title: 'Aangemaakt', dataIndex: 'created_at', key: 'created_at',
            render: (date) => date ? dayjs(date).format('DD-MM-YYYY') : '-',
        },
        {
            title: 'Acties', key: 'actions', width: 120,
            render: (_, affiliate) => (
                <Button size="small" icon={<PrinterOutlined />} onClick={() => handlePrintFlyer(affiliate)}>
                    Flyer
                </Button>
            ),
        },
    ];

    const requestColumns = [
        {title: 'Naam', dataIndex: 'name', key: 'name'},
        {title: 'E-mail', dataIndex: 'email', key: 'email'},
        {title: 'IBAN', dataIndex: 'iban', key: 'iban'},
        {title: 'KVK', dataIndex: 'kvk', key: 'kvk', render: (v) => v || '-'},
        {
            title: 'Korting', dataIndex: 'member_discount', key: 'member_discount',
            render: (v) => `${v}%`,
        },
        {
            title: 'Datum', dataIndex: 'created_at', key: 'created_at',
            render: (date) => date ? dayjs(date).format('DD-MM-YYYY') : '-',
        },
        {
            title: 'Acties', key: 'actions', width: 200,
            render: (_, record) => (
                <Row gutter={8}>
                    <Col>
                        <Button size="small" type="primary" icon={<CheckOutlined />} onClick={() => handleApproveRequest(record)}>
                            Goedkeuren
                        </Button>
                    </Col>
                    <Col>
                        <Button size="small" danger icon={<CloseOutlined />} onClick={() => handleDenyRequest(record)}>
                            Afwijzen
                        </Button>
                    </Col>
                </Row>
            ),
        },
    ];

    const processedRequestColumns = [
        {title: 'Naam', dataIndex: 'name', key: 'name'},
        {title: 'E-mail', dataIndex: 'email', key: 'email'},
        {title: 'Korting', dataIndex: 'member_discount', key: 'member_discount', render: (v) => `${v}%`},
        {
            title: 'Status', key: 'status',
            render: (_, r) => r.is_approved
                ? <Tag color="green">Goedgekeurd</Tag>
                : <Tag color="red">Afgewezen: {r.denial_reason}</Tag>,
        },
        {
            title: 'Datum', dataIndex: 'created_at', key: 'created_at',
            render: (date) => date ? dayjs(date).format('DD-MM-YYYY') : '-',
        },
    ];

    const discountColumns = [
        {title: 'ID', dataIndex: 'id', key: 'id', width: 60},
        {title: 'Code', dataIndex: 'code', key: 'code'},
        {title: 'Korting', dataIndex: 'discount', key: 'discount', render: (v) => `\u20AC${v}`},
        {
            title: 'Actief', dataIndex: 'is_active', key: 'is_active',
            render: (v) => v ? <Tag color="green">Actief</Tag> : <Tag color="red">Inactief</Tag>,
        },
        {title: 'Gebruikt', key: 'usage', render: (_, r) => `${r.used || 0} / ${r.max_usage || '\u221E'}`},
        {
            title: 'Verloopt', dataIndex: 'expires_at', key: 'expires_at',
            render: (v) => v ? dayjs(v).format('DD-MM-YYYY') : '-',
        },
        {
            title: 'Acties', key: 'actions', width: 160,
            render: (_, record) => (
                <Row gutter={8}>
                    <Col>
                        <Button size="small" icon={<EditOutlined />} onClick={() => handleEditDiscount(record)} />
                    </Col>
                    <Col>
                        <Button size="small" danger icon={<DeleteOutlined />} onClick={() => handleDeleteDiscount(record.id)} />
                    </Col>
                </Row>
            ),
        },
    ];

    return (
        <>
            {/* Deny modal */}
            <Modal
                title="Aanvraag afwijzen"
                open={denyModalOpen}
                onOk={handleDenySubmit}
                onCancel={() => setDenyModalOpen(false)}
                okText="Afwijzen"
                okButtonProps={{danger: true}}
            >
                <p>Geef een reden voor het afwijzen van de aanvraag van <strong>{denyingRequest?.name}</strong>:</p>
                <Form form={denyForm} layout="vertical">
                    <Form.Item
                        name="denial_reason"
                        rules={[{required: true, message: 'Reden is verplicht'}]}
                    >
                        <Input.TextArea rows={3} placeholder="bijv. KVK-nummer niet gevonden" />
                    </Form.Item>
                </Form>
            </Modal>

            {/* Create affiliate drawer */}
            <Drawer
                title="Nieuwe affiliate"
                width={500}
                open={drawerOpen}
                onClose={() => {
                    setDrawerOpen(false);
                    form.resetFields();
                }}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="affiliate_request_id" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="Naam"
                        rules={[{required: true, message: 'Naam is verplicht'}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="slug"
                        label="Slug (voor de affiliate link)"
                        rules={[{required: true, message: 'Slug is verplicht'}]}
                    >
                        <Input placeholder="bijv. tuincentrum-groen" />
                    </Form.Item>

                    <Form.Item name="affiliate_iban" label="IBAN (voor uitbetalingen)">
                        <Input placeholder="NL00BANK0000000000" />
                    </Form.Item>

                    <h4 style={{marginTop: 16, marginBottom: 8}}>Kortingscode (optioneel)</h4>

                    <Form.Item name="discount_code" label="Code">
                        <Input placeholder="bijv. VTV25" />
                    </Form.Item>

                    <Form.Item name="discount_amount" label="Kortingsbedrag (EUR)">
                        <InputNumber min={0} step={1} style={{width: '100%'}} placeholder="bijv. 9" />
                    </Form.Item>

                    <Form.Item name="discount_max_usage" label="Max gebruik">
                        <InputNumber min={1} style={{width: '100%'}} />
                    </Form.Item>

                    <Form.Item>
                        <Row gutter={8}>
                            <Col>
                                <Button onClick={() => setDrawerOpen(false)}>Annuleren</Button>
                            </Col>
                            <Col>
                                <Button type="primary" onClick={handleSubmit}>Aanmaken</Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Drawer>

            {/* Discount code drawer */}
            <Drawer
                title={editingDiscount ? 'Kortingscode bewerken' : 'Nieuwe kortingscode'}
                width={400}
                open={discountDrawerOpen}
                onClose={() => setDiscountDrawerOpen(false)}
            >
                <Form form={discountForm} layout="vertical">
                    <Form.Item name="code" label="Code" rules={[{required: true, message: 'Code is verplicht'}]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="discount" label="Korting (EUR)" rules={[{required: true, message: 'Kortingsbedrag is verplicht'}]}>
                        <InputNumber min={0} step={1} style={{width: '100%'}} />
                    </Form.Item>
                    <Form.Item name="is_active" label="Actief" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                    <Form.Item name="max_usage" label="Max gebruik">
                        <InputNumber min={1} style={{width: '100%'}} />
                    </Form.Item>
                    <Form.Item>
                        <Row gutter={8}>
                            <Col><Button onClick={() => setDiscountDrawerOpen(false)}>Annuleren</Button></Col>
                            <Col><Button type="primary" onClick={handleDiscountSubmit}>Opslaan</Button></Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Drawer>

            {/* Hidden flyer for printing */}
            {flyerAffiliate && (
                <div style={{position: 'absolute', left: '-9999px', top: 0}}>
                    <FlyerContent ref={flyerRef} affiliate={flyerAffiliate} />
                </div>
            )}

            <h1>Admin</h1>

            <Tabs
                activeKey={getActiveTab()}
                onChange={handleTabChange}
                items={[
                    {label: 'Stats', key: 'stats', children: null},
                    {label: 'Suppliers', key: 'suppliers', children: null},
                    {label: 'Icons', key: 'icons', children: null},
                    {label: 'Users', key: 'users', children: null},
                    {label: 'Blog Posts', key: 'blog', children: null},
                    {label: 'Ad Spends', key: 'ad-spends', children: null},
                    {
                        label: 'Affiliates',
                        key: 'affiliates',
                        children: (
                            <Tabs
                                activeKey={activeSubTab}
                                onChange={setActiveSubTab}
                                items={[
                                    {
                                        label: <>Aanvragen {pendingRequests.length > 0 && <Tag color="red">{pendingRequests.length}</Tag>}</>,
                                        key: 'requests',
                                        children: (
                                            <>
                                                <Row style={{marginBottom: 16}}>
                                                    <Col>
                                                        <Button
                                                            icon={<LinkOutlined />}
                                                            onClick={() => {
                                                                navigator.clipboard.writeText('https://oogst.app/affiliate-aanmelden');
                                                                message.success('Link gekopieerd');
                                                            }}
                                                        >
                                                            Kopieer aanmeldlink
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                {pendingRequests.length > 0 && (
                                                    <>
                                                        <h3 style={{marginBottom: 12}}>Openstaande aanvragen</h3>
                                                        <Table
                                                            dataSource={pendingRequests}
                                                            columns={requestColumns}
                                                            rowKey="id"
                                                            pagination={false}
                                                            style={{marginBottom: 32}}
                                                        />
                                                    </>
                                                )}
                                                {pendingRequests.length === 0 && (
                                                    <p style={{color: '#999', marginBottom: 16}}>Geen openstaande aanvragen.</p>
                                                )}
                                                {processedRequests.length > 0 && (
                                                    <>
                                                        <h3 style={{marginBottom: 12}}>Verwerkte aanvragen</h3>
                                                        <Table
                                                            dataSource={processedRequests}
                                                            columns={processedRequestColumns}
                                                            rowKey="id"
                                                            pagination={false}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        ),
                                    },
                                    {
                                        label: 'Affiliate bedrijven',
                                        key: 'companies',
                                        children: (
                                            <>
                                                <Row style={{marginBottom: 16}}>
                                                    <Col span={12}>
                                                        <h3>Affiliate bedrijven</h3>
                                                    </Col>
                                                    <Col span={12} style={{textAlign: 'right'}}>
                                                        <Button type="primary" icon={<PlusOutlined />} onClick={() => handleCreate()}>
                                                            Nieuwe affiliate
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Table
                                                    dataSource={affiliates}
                                                    columns={affiliateColumns}
                                                    rowKey="id"
                                                    loading={loading}
                                                    pagination={false}
                                                />
                                            </>
                                        ),
                                    },
                                    {
                                        label: 'Kortingscodes',
                                        key: 'discount-codes',
                                        children: (
                                            <>
                                                <Row style={{marginBottom: 16}}>
                                                    <Col span={12}>
                                                        <h3>Kortingscodes</h3>
                                                    </Col>
                                                    <Col span={12} style={{textAlign: 'right'}}>
                                                        <Button type="primary" icon={<PlusOutlined />} onClick={handleCreateDiscount}>
                                                            Nieuwe kortingscode
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Table
                                                    dataSource={discountCodes}
                                                    columns={discountColumns}
                                                    rowKey="id"
                                                    pagination={false}
                                                />
                                            </>
                                        ),
                                    },
                                ]}
                            />
                        )
                    },
                ]}
            />
        </>
    );
}
